var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoVisit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 101,
    viewBox: "0 0 99 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 47.5L35.4 57.9L0 22.5L22.5 0L41.4 18.9C41.1 19.1 40.9 19.3 40.6 19.6C39.1 21.1 38.4 23 38.4 24.9C38.4 26.8 39.1 28.7 40.6 30.2L47.2 36.8C46.6 37.7 46.1 38.7 45.8 39.8C44.9 42.3 45 45 45.8 47.5Z",
    transform: "translate(6.59961 6.77667)",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.075 0C-1.025 4.1 -1.025 10.8 3.075 15L31.875 43.8C36.275 48.2 42.975 48.9 48.075 45.8L57.175 54.9L81.875 30.2L70.275 18.6",
    transform: "translate(6.0249 34.2767)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5767 58.2767L46.6767 66.1767C45.5767 67.2767 43.7767 67.1767 42.6767 66.0767L0.876702 24.1767C-0.223298 23.0767 -0.323298 21.2767 0.776702 20.1767L20.1767 0.776702C21.2767 -0.323298 23.0767 -0.223298 24.1767 0.876702L46.4767 23.1767",
    transform: "translate(2.12305 2)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.2H7.5V0",
    transform: "translate(21.3999 19.1767)",
    stroke: "#FBAC1F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1 3L37.9 6.8L6.8 37.9L3 34.1L34.1 3ZM34.1 0C33.3 0 32.6 0.299998 32 0.899998L0.9 32C-0.3 33.2 -0.3 35.1 0.9 36.3L4.7 40.1C5.3 40.7 6.1 41 6.8 41C7.5 41 8.3 40.7 8.9 40.1L40 9C41.2 7.8 41.2 5.9 40 4.7L36.2 0.899998C35.6 0.299998 34.9 0 34.1 0Z",
    transform: "translate(58.0996 59.3767)",
    fill: "#007EE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23L23 0",
    transform: "translate(6.59961 6.07672)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 36.2689C9.7 34.7689 8.2 32.6689 7.4 30.2689C6.6 27.8689 6.5 25.1689 7.4 22.4689C7.7 21.3689 8.2 20.3689 8.8 19.4689L2.2 12.8689C0.699997 11.3689 0 9.46887 0 7.56887C0 5.66887 0.699997 3.76887 2.2 2.26887C2.4 2.06887 2.7 1.76887 3 1.56887C3.2 1.36887 3.5 1.26887 3.7 1.06887C6.6 -0.631134 10.4 -0.331133 12.9 2.16887L28.8 18.0689C31.2 20.9689 32.3 24.8689 31.5 28.6689",
    transform: "translate(44.9995 24.0078)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4L10.4 0",
    transform: "translate(41.9995 54.2767)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4722 70.0713) scale(67.3162) rotate(-135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVisit);
export default __webpack_public_path__ + "static/media/no-visit.8cef6399450f1a3c752b772b3f513be0.svg";
export { ForwardRef as ReactComponent };